<template>
    <div>
        <ul class="school flex-layout">
            <li class="school-li flex-layout"
                v-for="(li,index) in schoolList" 
                :key="index"
                :class="calcStyle"
                @click="$router.push('/news/school/detail/'+li.id)">
                <img :src="li.cover" alt="">
                <div class="describe">
                    <h3 class="f16 wes-2">{{li.name}}</h3>
                    <p class="wes-3">{{li.describe}}</p>
                    <!-- :style="pWidth" -->
                </div>
            </li>
        </ul>
        <div class="loading" v-if="showBtn">
            <!-- <button class="load-more" @click="getNewsList()" :class="[loadClass?'load-more':'load-more-none']">{{loadText}}</button>                   -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cloumn: {
          type:Number
        },
        width:{
          type:Number
        },
        pageSize:{
            type:Number
        }
    },
    data() {
        return {
            currentPage:1,
            loadText:'加载更多',
            loadClass:true,
            schoolList:[],
        }
    },
    computed:{
        calcStyle:function() {
            let lof = 'u-lof'
            this.cloumn ? lof = 'u-lof' + String(this.cloumn) : ''
            return lof;
        },
        showBtn:function(){
            return this.$route.path !== '/news' ? true : false;
        }
    },
    methods: {
        async GetSchoolList(){
            // if(this.pageSize == 3) {
            //     this.currentPage = 1
            // } else {
            //     this.currentPage++
            // }
            let params = {
                isAsc:'desc',
                pageNum:this.currentPage,
                pageSize:this.pageSize || 7
            }
            let resData = await Api.News.getSchoolList(params)
            console.log(resData.rows)
            params.pageNum = this.currentPage;
            let res = await Api.News.getSchoolList(params)
            // if(res.rows.length < 1) {
            //     this.loadText = '加载已完成'
            //     this.loadClass = false;
            // }
            // this.schoolList = this.schoolList.concat(resData.rows);
            this.schoolList = resData.rows;

         },
    },
    mounted(){
        this.GetSchoolList();
    },
    activated() {
        this.GetSchoolList();
    },
    deactivated() {
        this.currentPage=1
    }
    
}
</script>

<style lang="less" scoped>
    .school {
        // padding: 41px 20px 16px;
        flex-flow: row wrap;
        align-content: flex-start;

        .school-li {
            margin-bottom: 20px;
            cursor: pointer;

            img {
                display: inline-block;

                width: 190px;
                height: 190px;

                background-color: #1c4b90;
            }
            .describe {
                flex: 1;
                padding:0 4px 0 19px;

                &:hover h3, 
                &:hover p {
                    color: #1c4b90;
                }
                 h3 {
                     padding: 23px 0 0;
                     margin-bottom: 19px;
                 }
                 p {
                    // width: 335px;
                    
                    font-size: 12px;
                    color: #999;
                 }
            } 
        }
        
        .u-lof {
            width: 100%;
        }
        
        .u-lof4 {
            flex: 0 0 24%;
        }

        .u-lof3 {
            flex: 0 0 33%;
        }

        .u-lof2 {
            flex: 0 0 50%;
            .describe {
                padding: 0 20px;
            }



        }
    }

     .loading {
        .load-more {
           margin: 0 auto 88px;
           display: block;
           font-size: 12px;
           color: #333;
           border: 0;
           background: none;
           text-transform: uppercase;
           color: #333;
           font-weight: bold;
           position: relative;
           outline: none;
           padding: 10px 30px;
           box-sizing: border-box;
           cursor: pointer;

          &::before,   &::after {
            box-sizing: inherit;
            position: absolute;
            content: '';
            border: 2px solid transparent;
            width: 0;
            height: 0;
          }
          
          &::after {
            bottom: 0;
            right: 0;
          }
          
          &::before {
            top: 0;
            left: 0;
          }
          &:hover {
             color: #1B4B8F;
          }
 
          &:hover::before,  &:hover::after {
            width: 100%;
            height: 100%;
          }
          
          &:hover::before {
            border-top-color: #1B4B8F;
            border-right-color: #1B4B8F;
            transition: width 0.3s ease-out, height 0.3s ease-out 0.3s;
          }
          
          &:hover::after {
            border-bottom-color: #1B4B8F;
            border-left-color: #1B4B8F;
            transition: border-color 0s ease-out 0.6s, width 0.3s ease-out 0.6s, height 0.3s ease-out 1s;
          }
        }

        .load-more-none {
            color: #999;
            &::before,
            &::after {
                content: none;
            }

            &:hover {
                color: #999;
            }
        }
    }
        
</style>